//@flow
import type { ReducerState$Type,EditForm$Type } from '../genericFlowTypes'

export const transformDataToEditFormData=(data:any,rhea: ReducerState$Type)=>{
    let formData: EditForm$Type = {}
    
    const rheaResultsetData = data['rheaResultset']
    formData.isInvalidDoc = rheaResultsetData['is_invalid_doc']?rheaResultsetData['is_invalid_doc']:false
    formData.isOverrideVendorName = rheaResultsetData['is_override_vendor_name']?rheaResultsetData['is_override_vendor_name']:false
    formData.isGlStringNotFound = rheaResultsetData['is_gl_string_not_found']?rheaResultsetData['is_gl_string_not_found']:false
    
    if (rheaResultsetData['inv_no']){
        formData.invNo = rheaResultsetData['inv_no']
    }
    if (rheaResultsetData['inv_date']){
        formData.invDate = rheaResultsetData['inv_date']
    }
    if (rheaResultsetData['dept_no']){
        formData.deptNo = rheaResultsetData['dept_no']
    }
    if (rheaResultsetData['requestor']){
        formData.requestor = rheaResultsetData['requestor']
    }
    if (rheaResultsetData['po_no']){
        formData.poNo = rheaResultsetData['po_no']
    }
    if (rheaResultsetData['gl_string']){
        formData.glString = rheaResultsetData['gl_string']
    }
    if (rheaResultsetData['tax']){
        formData.tax = parseFloat(rheaResultsetData['tax'])
    }
    if (rheaResultsetData['additional']){
        formData.additional = parseFloat(rheaResultsetData['additional'])
    }
    if (rheaResultsetData['total']){
        formData.total = parseFloat(rheaResultsetData['total'])
    }
    if (rheaResultsetData['vendor_name']){
        formData.vendorName = rheaResultsetData['vendor_name']
    }
    if (rheaResultsetData['supplier_id']){
        formData.supplierId = rheaResultsetData['supplier_id']
    }
    if (rheaResultsetData['internal_id']){
        formData.internalId = rheaResultsetData['internal_id']
    }
    if (rheaResultsetData['modifier']){
        formData.modifier = rheaResultsetData['modifier']
    }
    if (rheaResultsetData['account']){
        formData.account = rheaResultsetData['account']
    }
    if (rheaResultsetData['requestor_id']){
        formData.requestorId = rheaResultsetData['requestor_id']
    }
    
    return formData
}


// WEBPACK FOOTER //
// ./src/redux/rhea/editFormData.js